import React, { useMemo } from "react";
import { ChevronDown } from "lucide-react";

const Step1 = ({ currentStep, totalSteps, answers, setAnswers, scholarships, onNext }) => {
	const targetOptions = useMemo(() => {
		if (!answers.targetType) {
			return [];
		}

		return scholarships.filter((item) => item.type === answers.targetType && item.is_active);
	}, [answers.targetType, scholarships]);

	const canContinue = Boolean(answers.targetType && answers.targetId && answers.degreeLevel);

	return (
		<>
			<p className="st-font-body st-text-body-muted text-[14px] sm:text-[15px]">
				Step {currentStep} of {totalSteps}
			</p>

			<h1 className="st-font-body mt-1.5 text-[28px] font-bold leading-[1.15] text-[#212121] sm:text-[34px]">
				<span className="mr-2 inline-block h-2 w-2 rounded-full bg-[#BB230B] align-middle" />
				Apa Target Kamu?
			</h1>
			<p className="st-font-body st-text-body-muted mt-1.5 text-[16px] sm:text-[18px]">Pilih jenis target dan nama spesifiknya.</p>

			<div className="mt-4 space-y-4">
				<div>
					<h2 className="st-font-body text-[22px] font-bold leading-[1.2] text-[#282828] sm:text-[24px]">Kategori target</h2>
					<div className="mt-2 space-y-2">
						<button
							type="button"
							onClick={() =>
								setAnswers((prev) => ({
									...prev,
									targetType: "scholarship",
									targetId: "",
									targetName: "",
								}))
							}
							className={`st-focus-ring st-font-body st-readiness-option ${
								answers.targetType === "scholarship" ? "st-readiness-option-active" : ""
							}`}
						>
							<span className="st-readiness-radio" aria-hidden="true" />
							Beasiswa Luar Negeri
						</button>

						<button
							type="button"
							onClick={() =>
								setAnswers((prev) => ({
									...prev,
									targetType: "university",
									targetId: "",
									targetName: "",
								}))
							}
							className={`st-focus-ring st-font-body st-readiness-option ${
									answers.targetType === "university" ? "st-readiness-option-active" : ""
							}`}
						>
							<span className="st-readiness-radio" aria-hidden="true" />
							Universitas luar negeri (S1 self-funded)
						</button>
					</div>
				</div>

				<div>
					<h2 className="st-font-body text-[22px] font-bold leading-[1.2] text-[#282828] sm:text-[24px]">Pilih target spesifik</h2>
					<div className="relative mt-2">
						<select
								value={answers.targetId}
							onChange={(event) =>
									{
										const selected = targetOptions.find((item) => String(item.id) === event.target.value);
										setAnswers((prev) => ({
											...prev,
											targetId: event.target.value,
											targetName: selected?.name || "",
										}));
									}
							}
							className="st-focus-ring st-font-body st-readiness-select appearance-none"
								disabled={!answers.targetType}
						>
								<option value="">{answers.targetType ? "Pilih target" : "Pilih kategori target dulu"}</option>
								{targetOptions.map((option) => (
									<option key={option.id} value={String(option.id)}>
										{option.name}
								</option>
							))}
						</select>
						<ChevronDown size={20} className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[#555]" />
					</div>
				</div>

				<div>
					<h2 className="st-font-body text-[22px] font-bold leading-[1.2] text-[#282828] sm:text-[24px]">Jenjang Studi</h2>
					<div className="mt-2 space-y-2">
						{[
								{ value: "S1", label: "S1 (Undergraduate)" },
								{ value: "S2", label: "S2 (Master)" },
								{ value: "S3", label: "S3 (PhD)" },
						].map((item) => (
							<button
								key={item.value}
								type="button"
								onClick={() =>
									setAnswers((prev) => ({
										...prev,
											degreeLevel: item.value,
									}))
								}
								className={`st-focus-ring st-font-body st-readiness-option ${
										answers.degreeLevel === item.value ? "st-readiness-option-active" : ""
								}`}
							>
								<span className="st-readiness-radio" aria-hidden="true" />
								{item.label}
							</button>
						))}
					</div>
				</div>
			</div>

			<div className="mt-5 flex justify-end">
				<button type="button" disabled={!canContinue} className="st-focus-ring st-readiness-next" onClick={onNext}>
					Next →
				</button>
			</div>
		</>
	);
};

export default Step1;
